module.exports = __webpack_public_path__ + "media/bg.b7128078.mp3";